import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["size", "status", "width", "className", "forwardedRef"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { CustomPropTypes } from '@beef/react';
import { withForwardedRef } from "../../../enhancers";
import styles from "../styles.pcss";
import { valueToPixel } from "../enhancers/helpers";
var cx = classNames.bind(styles);

/**
 * Input with visual customization
 */
var InputView = /*#__PURE__*/function (_Component) {
  _inherits(InputView, _Component);
  var _super = _createSuper(InputView);
  function InputView() {
    var _this;
    _classCallCheck(this, InputView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * we have to override onChange, onFocus and onBlur,
     * normally they fire with event as first argument,
     * we put value as first argument, event as second
     */
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var onChange = _this.props.onChange;
      if (onChange) onChange(event.target.value, event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      var _this$props = _this.props,
        onFocus = _this$props.onFocus,
        value = _this$props.value;
      if (onFocus) onFocus(value, event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var _this$props2 = _this.props,
        onBlur = _this$props2.onBlur,
        value = _this$props2.value;
      if (onBlur) onBlur(value, event);
    });
    return _this;
  }
  _createClass(InputView, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        size = _this$props3.size,
        status = _this$props3.status,
        width = _this$props3.width,
        className = _this$props3.className,
        forwardedRef = _this$props3.forwardedRef,
        otherProps = _objectWithoutProperties(_this$props3, _excluded);

      /**
       * Fields like status and size are passed straight into class, the validation is done in propTypes
       */
      var classes = cx('component', size, status, className);
      return /*#__PURE__*/React.createElement("input", _extends({
        autoComplete: "on",
        style: {
          maxWidth: valueToPixel(width)
        }
      }, otherProps, {
        className: classes,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        ref: forwardedRef,
        "data-t-id": "TextInputV2-views"
      }));
    }
  }]);
  return InputView;
}(Component);
InputView.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.oneOf(['fail']),
  size: PropTypes.oneOf(['big']),
  /**
   * width of input, HOCs that override DOM container are supposed to apply width to their container
   */
  width: PropTypes.number,
  className: PropTypes.string,
  /**
   * some notable default input props are listed here
   * all the other props are simply passed down
   */
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  /** is not an actual prop */
  forwardedRef: CustomPropTypes.ref
} : {};
export default withForwardedRef(InputView);